import React from 'react'
import './Trellosidebar.css'

const YourBoard = () => {
  return (
    <div>
        <p className = 'wrkspcdiv'> Your Board</p>
    </div>
  )
}

export default YourBoard